<template>
  <div>
    <v-dialog
      v-model="showDialog"
      max-width="406"
      flat
      elevation="0"
      persistent
    >
      <v-card color="greyColorLigthTwo" class="rounded-lg py-5">
        <v-card-title
          class="justify-center pb-0 mb-0 defaultColor--text text-center"
          style="word-break: break-word"
        >
          {{ selectedItem.Title }}
        </v-card-title>
        <v-card-actions class="justify-center align-center d-flex flex-column mt-4 px-10">
          <v-btn
            v-for="(item, i) in selectedItem.Properties"
            :key="i"
            v-if="item.Value != ''"
            color="defaultColor"
            class="white--text text-lowercase mb-3 ml-0"
            elevation="0"
            block
            rounded
            large
            @click="clickButtonDialog(item.Key, item.Value)"
          >
            {{ item.Key == 'link' ? $t('buttons.gotoLink') : item.Value }}
          </v-btn>
        </v-card-actions>
      </v-card>

      <dialog-close-button @clickButton="closeDialog" />
    </v-dialog>

    <v-container grid-list-xl class="word-wrap">
      <v-layout row wrap justify-center mt-5>
        <v-flex
          xs12
          md8
          sm12
          justify-center
          align-center
          style="max-width: 670px"
          ><h3 class="font-weight-bold defaultColor--text">
            {{ $t("title.communityApps") }}
          </h3>
          <v-spacer
        /></v-flex>
      </v-layout>
      <v-layout row wrap justify-center mt-2>
        <!-- Feeds-->
        <v-flex
          xs12
          md8
          sm12
          justify-center
          align-center
          style="max-width: 670px"
        >
          <div
            v-for="(item, i) in data"
            :key="i"
            class="mr-3 ml-3 mb-6"
            style="float: left"
          >
            <v-card
              class="rounded-lg pt-4"
              flat
              color="white"
              height="190"
              width="190"
              @click="clickCard(item)"
            >
              <v-card-title
                class="mx-4 pa-0 justify-center"
                style="word-break: break-word"
              >
                <v-avatar tile width="120" height="120">
                  <v-img :src="mainImage(item)" contain></v-img>
                </v-avatar>
              </v-card-title>
              <v-card-title
                class="mx-4 pa-0 mt-3 defaultColor--text font-weight-bold text-center justify-center"
                style="
                  word-break: break-word;
                  font-size: 14px;
                  line-height: 20px;
                "
              >
                {{ item.Title }}</v-card-title
              >
            </v-card>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import ContentService from "@/services/ContentService";
import DialogCloseButton from "../../components/General/DialogCloseButton.vue";
export default {
  data: () => {
    return {
      page: 1,
      pageSize: 50,
      data: [],
      loadMoreLoading: false,
      paginationStop: false,

      showDialog: false,
      selectedItem: [],
    };
  },
  components: {
    DialogCloseButton
  },
  methods: {
    getContent() {
      this.page == 1 ? setPageLoading(true) : (this.loadMoreLoading = true);
      ContentService.getContent("other_applications", this.page, this.pageSize)
        .then((res) => {
          if (this.page != 1) {
            this.data = [...this.data, ...res.data];
          } else {
            this.data = res.data;
          }
          if (res.data.length <= 0) {
            this.noData = true;
            this.paginationStop = true;
            //this.data = [];
          }
        })
        .catch((err) => {
          showError(err);
        })
        .then(() => {
          this.page == 1
            ? setPageLoading(false)
            : (this.loadMoreLoading = false);
        });
    },

    mainImage(item) {
      if (item.Files.length > 0) {
        return item.Files[0].LocalUrl;
      } else {
        return null;
      }
    },

    clickCard(item) {
      const { Properties } = item;
      let link = Properties.filter((i) => i.Key === "link")[0].Value;
      let mailTo = Properties.filter((i) => i.Key === "mail_to")[0].Value;
      let phone = Properties.filter((i) => i.Key === "Phone")[0].Value;
      if ((link !== "") & (mailTo === "") & (phone === "")) {
        //Open Link
        openLink(link ? link : null);
      } else {
        //Open Modal
        this.selectedItem = item;
        this.showDialog = true;
      }
    },

    clickButtonDialog(key, value) {
      if (key === 'link') {
        //Open Link
        openLink(value ? value : null);
      } else {
        //Copy value
        navigator.clipboard.writeText(value);
        this.showInfo(this.$t('description.copyToClipboard'), "standart", "success");
      }
    },

    closeDialog(){
        this.selectedItem = []
        this.showDialog = false
    }
  },
  computed: {},
  destroyed() {},
  mounted() {
    this.getContent();
  },
  watch: {},
};
</script>

<style></style>
